/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getLedgerByCustomer, postLedger } from "src/shared/api";
import { singleLedger } from "src/shared/services/interfacev2";

export interface PaymentAppliedResponse {
  message: string;
  billNumber: number;
  return_data: {
    current_outstanding_balance: number;
    discount: number;
    paid_amount: number;
    previous_outstanding_balance: number;
  };
}

const useSpecifiedLedger = (id: string, pageNumber: number, pageSize: number, includeHistory?: boolean, sortField?: string, sortOrder?: string) => {
  const [ledgers, setLedgers] = useState<singleLedger | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchLedgersAsync = (): Promise<void> => {
    return getLedgerByCustomer(id, pageNumber, pageSize, includeHistory, sortField, sortOrder)
      .then((res) => {
        setLedgers(res?.data.ledger);
      })
      .catch((error) => console.error(error));
  };

  const fetchLedgers = () => {
    if (!id) return;
    setLoading(true);
    getLedgerByCustomer(id, pageNumber, pageSize, includeHistory, sortField, sortOrder)
      .then((res) => {
        setLedgers(res?.data.ledger);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  };

  const postAndRefresh = async (data: any): Promise<PaymentAppliedResponse> => {
    setLoading(true);
    try {
      const res = await postLedger(data);
      setLedgers(null);
      await fetchLedgersAsync();
      console.log("res", res)
      const getResponse: PaymentAppliedResponse = res.data
      return getResponse;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedgers();
  }, [id, pageNumber, pageSize, includeHistory, sortField, sortOrder]);

  return { ledgers, loading, setLedgers, postAndRefresh };
};

export default useSpecifiedLedger;
